module.exports = __webpack_public_path__ + "img/ey.22978f5e.svg";